module.exports = __webpack_public_path__ + "img/icons BFr_7.555d361e.svg";